import React, { Component, ReactNode } from 'react';
import { Api, EventBus } from 'src/helpers/new';
import './ExamBanner.scss';
import { Button } from 'react-bootstrap';
import Countdown from 'react-countdown';
import { first, isNil } from 'lodash';
import { RouteComponentProps } from 'src/hoc/withRouter';
import { IUserLoggedIn } from 'src/layouts/Main/UserBar/Menus/ProfilePopOver';
import withRouterAndRedux from 'src/hoc/withRouterAndRedux';

interface ICurrentExam {
    startedAt: string[];
    timeLimit: number;
    title: string;
    userCourseId: string;
    _id: string;
    remainingTime: number;
}
interface IState {
    showBanner: boolean;
    currentExam?: ICurrentExam;
    endTime: number;
}

interface IProps extends RouteComponentProps {
    isShowExamBanner: boolean | null;
    loggedIn: IUserLoggedIn;
    setLoggedIn: (payload: any) => void;
}

class ExamBanner extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            showBanner: false,
            endTime: 0,
        };
    }

    getTimeRemaining(currentExam: ICurrentExam): number {
        if (isNil(currentExam?.remainingTime) || !currentExam) return 0;
        return currentExam?.remainingTime;
    }

    componentDidMount = async () => {
        if (this.props.loggedIn.user && isNil(this.props.isShowExamBanner)) {
            await this.getActiveExam();
        }
    };

    async componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        if (
            prevProps.loggedIn.user?._id !== this.props.loggedIn.user?._id ||
            (prevProps.isShowExamBanner !== this.props.isShowExamBanner && isNil(this.props.isShowExamBanner))
        ) {
            await this.getActiveExam();
        }
    }

    getActiveExam = async () => {
        const { success, response } = await Api.call('GET', '/users/exams/active');
        if (success && response.length > 0) {
            this.setState({
                showBanner: true,
                currentExam: first(response),
                endTime: Date.now() + this.getTimeRemaining(first(response) as ICurrentExam),
            });
            EventBus.dispatch('show-exam-banner', { isResume: true });
        } else {
            this.setState({
                showBanner: false,
            });
            EventBus.dispatch('show-exam-banner', { isResume: false });
        }
    };

    navigateToExam = () => {
        const { currentExam } = this.state;
        if (currentExam && currentExam.userCourseId) {
            if (this.state.endTime > 0) {
                const data = {
                    isResumeExam: true,
                };
                this.props.navigate(`/courses/${currentExam.userCourseId}/exam-summary`, {
                    replace: true,
                    state: { data },
                });
            } else {
                this.props.navigate(`/courses/${currentExam.userCourseId}/exam-summary`);
            }
        }
    };

    handleTimeExpired = () => {
        this.setState({ endTime: 0 });
    };

    render(): ReactNode {
        const { showBanner, currentExam, endTime } = this.state;
        return (
            showBanner &&
            currentExam && (
                <div className='exam-banner-container'>
                    <div className='banner-content'>
                        {endTime > 0 ? (
                            <span>
                                {`Exam in-progress:`}
                                <Countdown
                                    date={endTime}
                                    onComplete={this.handleTimeExpired}
                                    renderer={({ hours, minutes, seconds }) => {
                                        return (
                                            <span>
                                                {hours.toString().padStart(2, '0')}:
                                                {minutes.toString().padStart(2, '0')}:
                                                {seconds.toString().padStart(2, '0')}
                                            </span>
                                        );
                                    }}
                                />{' '}
                                {`remaining`}
                            </span>
                        ) : (
                            <span>{`You've run out of time for the exam.`}</span>
                        )}

                        <Button className='bp' onClick={this.navigateToExam}>
                            {endTime > 0 ? 'Resume Exam' : 'Check Summary'}
                        </Button>
                    </div>
                </div>
            )
        );
    }
}

export default withRouterAndRedux(ExamBanner, (state: any) => ({ loggedIn: state.loggedIn }), {
    setLoggedIn: (payload: any) => ({
        type: 'SET_LOGGED_IN',
        payload,
    }),
});
